module.exports = __webpack_public_path__ + "img/btn_grow.adde7418.png";